(function(){
  // Structured data (Product, Collection, Article, Organization, WebSite, Breadcrumb)
  // is emitted server-side by snippets/schema-jsonld.liquid and snippets/microdata-schema.liquid.
  // This file only handles DOM cleanup and meta tags.

  // ─── CLEANUP: Remove orphaned Pop-Convert H1 spam from DOM ───
  document.querySelectorAll('h1').forEach(function(el){
    var t=el.textContent.trim();
    if(/Thank you!|Please try again|You won|FREE SHIPPING|% OFF/i.test(t))el.remove();
    if(el.querySelector&&el.querySelector('[style*="Open Runde"]'))el.remove();
  });
  var pcBlock=document.getElementById('shopify-block-AenBHK0lKV1lteHBpM__18408366429334172745');
  if(pcBlock)pcBlock.remove();
  // Kill Pop-Convert popup completely — prevent it from ever showing
  window.myPC=null;window.PopConvert=null;
  document.querySelectorAll('[class*="pop-convert"],[class*="pc-campaign"],[id*="pop-convert"]').forEach(function(el){el.remove();});

  // ─── FIX TWITTER CARD (upgrade to large image) ───
  var tc=document.querySelector('meta[name="twitter:card"]');
  if(tc&&tc.content==='summary'){tc.content='summary_large_image';}

  // ─── GOOGLE DISCOVER + MAX SNIPPET optimization ───
  // max-image-preview:large = eligible for Google Discover large image cards
  // max-snippet:-1 = allow full snippets (featured snippet eligibility)
  // max-video-preview:-1 = allow full video previews
  var robotsMeta=document.querySelector('meta[name="robots"]');
  if(robotsMeta){robotsMeta.content+=(robotsMeta.content?', ':'')+'max-image-preview:large, max-snippet:-1, max-video-preview:-1';}
  else{var rm=document.createElement('meta');rm.name='robots';rm.content='max-image-preview:large, max-snippet:-1, max-video-preview:-1';document.head.appendChild(rm);}
})();
